export const ERROR_PAGE = '/error-page';
export const NOT_FOUND_PAGE = '/not-found';

// Portal Pages

export const PAGES = {
  BASE: '/',
  AIP: '/aip',
  PREPARE_REGISTRATION: '/prepare-registration',
  KYC_PROCESSING: '/kyc/processing',
  KYC_SUCCESS: '/kyc/success',
  KYC_VERIFICATION: '/kyc/verification',
  IMPERSONATE: '/impersonate',
  KYC_PROOF_OF_IDENTITY: {
    MAIN: {
      MAIN: '/kyc/proof-of-identity',
      UPLOAD: {
        DRIVERS_LICENSE: '/kyc/proof-of-identity/drivers-license',
        PASSPORT: '/kyc/proof-of-identity/passport',
        GOVERNMENT_ID: '/kyc/proof-of-identity/id',
      },
      UPLOAD_FILE: {
        DRIVERS_LICENSE: '/kyc/proof-of-identity/drivers-license/file',
        PASSPORT: '/kyc/proof-of-identity/passport/file',
        GOVERNMENT_ID: '/kyc/proof-of-identity/id/file',
      },
      UPLOAD_CAMERA: {
        DRIVERS_LICENSE: '/kyc/proof-of-identity/drivers-license/camera',
        PASSPORT: '/kyc/proof-of-identity/passport/camera',
        GOVERNMENT_ID: '/kyc/proof-of-identity/id/camera',
      },
    },
    SECONDARY: {
      MAIN: '/kyc/proof-of-identity/secondary',
      UPLOAD: {
        DRIVERS_LICENSE: '/kyc/proof-of-identity/secondary/drivers-license',
        PASSPORT: '/kyc/proof-of-identity/secondary/passport',
        GOVERNMENT_ID: '/kyc/proof-of-identity/secondary/id',
      },
      UPLOAD_FILE: {
        DRIVERS_LICENSE:
          '/kyc/proof-of-identity/secondary/drivers-license/file',
        PASSPORT: '/kyc/proof-of-identity/secondary/passport/file',
        GOVERNMENT_ID: '/kyc/proof-of-identity/secondary/id/file',
      },
      UPLOAD_CAMERA: {
        DRIVERS_LICENSE:
          '/kyc/proof-of-identity/secondary/drivers-license/camera',
        PASSPORT: '/kyc/proof-of-identity/secondary/passport/camera',
        GOVERNMENT_ID: '/kyc/proof-of-identity/secondary/id/camera',
      },
    },
    MINOR: {
      MAIN: '/kyc/proof-of-identity/minor',
      UPLOAD: {
        DRIVERS_LICENSE: '/kyc/proof-of-identity/minor/drivers-license',
        PASSPORT: '/kyc/proof-of-identity/minor/passport',
        GOVERNMENT_ID: '/kyc/proof-of-identity/minor/id',
      },
      UPLOAD_FILE: {
        DRIVERS_LICENSE: '/kyc/proof-of-identity/minor/drivers-license/file',
        PASSPORT: '/kyc/proof-of-identity/minor/passport/file',
        GOVERNMENT_ID: '/kyc/proof-of-identity/minor/id/file',
      },
      UPLOAD_CAMERA: {
        DRIVERS_LICENSE: '/kyc/proof-of-identity/minor/drivers-license/camera',
        PASSPORT: '/kyc/proof-of-identity/minor/passport/camera',
        GOVERNMENT_ID: '/kyc/proof-of-identity/minor/id/camera',
      },
    },
  },
  KYC_PROOF_OF_RESIDENCE: {
    MAIN: {
      MAIN: '/kyc/proof-of-residence',
      UPLOAD: {
        CREDIT_CARD_STATEMENT: '/kyc/proof-of-residence/credit-card-statement',
        UTILITY_BILL: '/kyc/proof-of-residence/utility-bill',
        BANK_STATEMENT: '/kyc/proof-of-residence/bank-statement',
        VOIDED_CHECK: '/kyc/proof-of-residence/voided-check',
      },
    },
    SECONDARY: {
      MAIN: '/kyc/proof-of-residence/secondary',
      UPLOAD: {
        CREDIT_CARD_STATEMENT:
          '/kyc/proof-of-residence/secondary/credit-card-statement',
        UTILITY_BILL: '/kyc/proof-of-residence/secondary/utility-bill',
        BANK_STATEMENT: '/kyc/proof-of-residence/secondary/bank-statement',
        VOIDED_CHECK: '/kyc/proof-of-residence/voided-check',
      },
    },
    MINOR: {
      MAIN: '/kyc/proof-of-residence/minor',
      UPLOAD: {
        CREDIT_CARD_STATEMENT:
          '/kyc/proof-of-residence/minor/credit-card-statement',
        UTILITY_BILL: '/kyc/proof-of-residence/minor/utility-bill',
        BANK_STATEMENT: '/kyc/proof-of-residence/minor/bank-statement',
        VOIDED_CHECK: '/kyc/proof-of-residence/voided-check',
      },
    },
  },
  KYC_PROOF_OF_SOCIAL_SECURITY: {
    MAIN: {
      UPLOAD: {
        SOCIAL_SECURITY_CARD: '/kyc/proof-of-social-security/ssc',
      },
      UPLOAD_FILE: {
        SOCIAL_SECURITY_CARD: '/kyc/proof-of-social-security/ssc/file',
      },
      UPLOAD_CAMERA: {
        SOCIAL_SECURITY_CARD: '/kyc/proof-of-social-security/ssc/camera',
      },
    },
    SECONDARY: {
      MAIN: '/kyc/proof-of-social-security/secondary',
      UPLOAD: {
        SOCIAL_SECURITY_CARD: '/kyc/proof-of-social-security/secondary/ssc',
      },
      UPLOAD_FILE: {
        SOCIAL_SECURITY_CARD:
          '/kyc/proof-of-social-security/secondary/ssc/file',
      },
      UPLOAD_CAMERA: {
        SOCIAL_SECURITY_CARD:
          '/kyc/proof-of-social-security/secondary/ssc/camera',
      },
    },
    MINOR: {
      MAIN: '/kyc/proof-of-social-security/minor',
      UPLOAD: {
        SOCIAL_SECURITY_CARD: '/kyc/proof-of-social-security/minor/ssc',
      },
      UPLOAD_FILE: {
        SOCIAL_SECURITY_CARD: '/kyc/proof-of-social-security/minor/ssc/file',
      },
      UPLOAD_CAMERA: {
        SOCIAL_SECURITY_CARD: '/kyc/proof-of-social-security/minor/ssc/camera',
      },
    },
  },
  KYC_PROOF_OF_OWNERSHIP: {
    MAIN: '/kyc/proof-of-ownership',
    UPLOAD: '/kyc/proof-of-ownership/upload',
  },
  KYC_DONE: '/kyc/done',
  KYC_DONE_SKIP: '/kyc/done-skip',
  CREATE_APPLICATION: {
    MAIN: '/create-application',
    STANDARD: {
      MAIN: '/create-application/standard',
    },
    RETIREMENT: {
      MAIN: '/create-application/retirement',
      BUSINESS: '/create-application/retirement/business',
      PERSONAL: '/create-application/retirement/personal',
    },
    UTMA: {
      MAIN: '/create-application/utma',
    },
  },
  CHOOSE_APPLICATION: {
    MAIN: '/choose-application',
    STANDARD: {
      MAIN: '/choose-application/standard',
    },
    RETIREMENT: {
      MAIN: '/choose-application/retirement',
      BUSINESS: '/choose-application/retirement/business',
      PERSONAL: '/choose-application/retirement/personal',
    },
    UTMA: {
      MAIN: '/choose-application/utma',
    },
  },
  LOGIN_PATH: '/login',
  CREATE_ACCOUNT: '/createAccount',
  CREATE_ACCOUNT_LOADING: '/createAccount/loading',
  CUSTOMER_EMAIL: '/customerEmail',
  INVITE_USER: '/sales-invitation',
  REVIEW_USER_HISTORY: '/reviewUserHistory',
  LOGIN_LOADING: '/login/loading',
  LOADING: '/loading',
  REFRESH_LOADING: '/refresh/loading',
  RESET_SENT: '/reset-sent',
  RESET_PASSWORD: '/reset-password',
  SET_PASSWORD: '/set-password',
  RESET_SUCCESSFUL_PAGE: '/reset-successful',
  SECURE_ACCOUNT: '/secure',
  SECURE_NAME: '/secure/name',
  SECURE_DOB: '/secure/dob',
  SECURE_IDENTITY: '/secure/identity',
  SECURE_IDENTITY_SSN: '/secure/identity/ssn',
  SECURE_IDENTITY_DETAILS: '/secure/identity/details',

  EMPLOYMENT_STATUS: '/secure/employmentStatus',
  SECURE_PHONE_NUMBER: '/secure/phone-number',
  SECURE_SECONDARY: '/secure/secondary',
  SECURE_SECONDARY_DOB: '/secure/secondary/dob',
  SECURE_SECONDARY_IDENTITY: '/secure/secondary/identity',
  SECURE_SECONDARY_SSN: '/secure/secondary/ssn',

  SECURE_SECONDARY_PHONE_NUMBER: '/secure/secondary/phone-number',

  SECURE_MARITAL: '/secure/marital',
  SECURE_BUSINESS_NAME: '/secure/businessName',
  SECURE_BUSINESS_TYPE: '/business/secure/verify',
  SECURE_BUSINESS_ORIGIN_NAME: '/business/secure/verify/name',
  SECURE_BUSINESS_ORIGIN_EIN: '/business/secure/verify/name/ein',
  SECURE_BUSINESS_ADDRESS: '/business/secure/verify/business-address',
  SECURE_BUSINESS_REVIEW: '/business/secure/verify/business-review',
  SECURE_TRUST_NAME: '/secure/trust/name',
  SECURE_TRUST_NAME_EIN_QUESTION: '/secure/trust/askEin',
  SECURE_TRUST_NAME_EIN: '/secure/trustName/ein',
  SECURE_MINOR: '/secure/minor',
  SECURE_MINOR_DOB: '/secure/minor/dob',
  SECURE_MINOR_IDENTITY: '/secure/minor/identity',
  SECURE_MINOR_SSN: '/secure/minor/ssn',

  SECURE_MINOR_PHONE_NUMBER: '/secure/minor/phone-number',
  ADDRESS: '/address',
  ADDRESS_ENTER: '/address/enter',
  ADDRESS_DONE: '/address/done',
  ADDRESS_SECONDARY: '/address/secondary',
  ADDRESS_SECONDARY_ENTER: '/address/secondary/enter',
  ADDRESS_MINOR: '/address/minor',
  ADDRESS_MINOR_ENTER: '/address/minor/enter',
  FUND: '/fund',
  FINANCIAL_PROFILE: '/secure/financial-profile',
  REVIEW: '/review',
  AGREEMENT: '/review/agreement',
  EQUITY_AGREEMENT: '/review/equity',
  METAL_STREAM: '/aip',
  METAL_STREAM_WELCOME: '/metal',
  METAL_STREAM_MONTHLY_INVEST: '/metal/invest',
  METAL_STREAM_FUND_ALLOCATION: '/metal/allocate',
  METAL_STREAM_GOLD: '/metal/gold',
  METAL_STREAM_SILVER: '/metal/silver',
  METAL_STREAM_FUNDING: '/metal/funding',
  METAL_STREAM_REVIEW: '/metal/review',
  METAL_STREAM_SUMMARY: '/metal/complete',
  METAL_SECURE_ACCOUNT: {
    SECURE_ACCOUNT: '/aip/secure',
    SECURE_NAME: '/aip/secure/name',
    SECURE_DOB: '/aip/secure/dob',
    SECURE_IDENTITY: '/aip/secure/identity',
    SECURE_IDENTITY_SSN: '/aip/secure/identity/ssn',

    SECURE_PHONE_NUMBER: '/aip/secure/phone-number',
    REVIEW: '/aip/review',
    AGREEMENT: '/aip/review/agreement',
    SECURE_SECONDARY: '/aip/secure/secondary',
    SECURE_SECONDARY_DOB: '/aip/secure/secondary/dob',
    SECURE_SECONDARY_IDENTITY: '/aip/secure/secondary/identity',
    SECURE_SECONDARY_SSN: '/aip/secure/secondary/ssn',

    SECURE_SECONDARY_PHONE_NUMBER: '/aip/secure/secondary/phone-number',
    SECURE_TRUST_NAME: '/aip/secure/trustName',
    SECURE_TRUST_NAME_EIN_QUESTION: '/aip/secure/trustName/askEin',
    SECURE_TRUST_NAME_EIN: '/aip/secure/trustName/ein',
    SECURE_BUSINESS_TYPE: '/aip/secure/business/verify',
    SECURE_BUSINESS_ORIGIN_NAME: '/aip/secure/business/verify/name',
    SECURE_BUSINESS_ORIGIN_EIN: '/aip/secure/business/verify/name/ein',
    SECURE_BUSINESS_ADDRESS: '/aip/secure/business/verify/address',
    SECURE_MINOR: '/aip/secure/minor',
    SECURE_MINOR_DOB: '/aip/secure/minor/dob',
    SECURE_MINOR_IDENTITY: '/aip/secure/minor/identity',
    SECURE_MINOR_SSN: '/aip/secure/minor/ssn',
  },
  BUSINESS_ACCOUNT: {
    SECURE_ACCOUNT: '/business/secure',
    SECURE_NAME: '/business/secure/name',
    SECURE_DOB: '/business/secure/dob',
    SECURE_IDENTITY: '/business/secure/identity',
    SECURE_IDENTITY_SSN: '/business/secure/identity/ssn',
    SECURE_PHONE_NUMBER: '/business/secure/phone-number',
  },
  FUNDING: {
    NORMAL_FUNDING: {
      ACCOUNT: '/fund/account',
      AMOUNT: {
        PLAID: '/fund/account/ach',
        WIRE: '/fund/account/wire',
        CHECK: '/fund/account/check',
        CRYPTOCURRENCY: '/fund/account/cryptocurrency',
      },
      JOINT_SURVIVOR: '/fund/account/survivor',
      JOINT_METAL_SURVIVOR: '/fund/metal/survivor',
    },
    RETIREMENT_FUNDING: {
      ACCOUNT: '/fund/retirement',
      AMOUNT: {
        ROLLOVER: '/fund/retirement/rollover/amount',
        ANNUAL_CONTRIBUTION: '/fund/retirement/contribution/amount',
      },
    },
    METALSTREAM_FUNDING: {
      ACCOUNT: '/metal/aip/fund',
      AMOUNT: '/metal/aip/amount',
    },
  },
  DELETE_APPLICATION: '/delete-application',
};

export const DASHBOARD = '/dashboard';
